import { render, staticRenderFns } from "./StallProducts.vue?vue&type=template&id=b0945e02&scoped=true"
import script from "./StallProducts.vue?vue&type=script&lang=js"
export * from "./StallProducts.vue?vue&type=script&lang=js"
import style0 from "./StallProducts.vue?vue&type=style&index=0&id=b0945e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0945e02",
  null
  
)

export default component.exports